export default class PurchaseOrder {
  constructor(po) {
    this.classificationId = po.classificationId;
    this.daysUntilExpiration = po.daysUntilExpiration;
    this.descriptionHtml = po.descriptionHtml;
    this.features = po.features;
    this.id = po.id;
    this.isFree = po.isFree;
    this.monthsUntilExpiration = po.monthsUntilExpiration;
    this.name = po.name;
    this.order = po.order;
    this.parentId = po.parentId;
    this.purchaseOrderType = po.purchaseOrderType;
    this.showOnWeb = po.showOnWeb;
    this.webAppCost = po.webAppCost;
    this.expiredBannerActionText = po.expiredBannerActionText;
    this.expiredBannerShowDays = po.expiredBannerShowDays;
    this.expiredBannerTextTemplate = po.expiredBannerTextTemplate;
    this.extendBannerActionText = po.extendBannerActionText;
    this.extendBannerShowDays = po.extendBannerShowDays;
    this.extendBannerTextTemplate = po.extendBannerTextTemplate;
    this.oneTimeSub = po.oneTimeSub;
    this.preferredModalHeader = po.preferredModalHeader;
    this.preferredModalSubHeader = po.preferredModalSubHeader;
  }

  get isAddonPurchaseOrder() {
    return this.purchaseOrderType === 'Add On' || this.purchaseOrderType === 'Extension';
  }

  get expiredBannerConfig() {
    return {
      actionText: this.expiredBannerActionText,
      showDays: this.expiredBannerShowDays,
      textTemplate: this.expiredBannerTextTemplate,
    };
  }

  get extendBannerConfig() {
    return {
      actionText: this.extendBannerActionText,
      showDays: this.extendBannerShowDays,
      textTemplate: this.extendBannerTextTemplate,
    };
  }

  // used for analytics/apptimize - format is like Fr (121)
  get formattedString() {
    return `${this.name.slice(0, 2)} (${this.id})`;
  }

  get costString() {
    return `$${(this.webAppCost / 100).toFixed(2)}`;
  }
}
